<template>
  <v-dialog v-model="isShowTicketDetail" width="600" scrollable @click:outside="handleClose">
    <v-card class="ticket-card">
      <v-card-title>
        Ticket của khách hàng {{ticket.customFields ? ticket.customFields.customerCode : ""}}
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="3">
            <div class="ticket-form-label">
              Người tạo
            </div>
          </v-col>
          <v-col cols="9" class="ticket-form-value">
            {{ticket.createdBy ? ticket.createdBy.username : '_'}}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <div class="ticket-form-label">
              Mã học sinh
            </div>
          </v-col>
          <v-col cols="9">
            {{ticket.customFields && ticket.customFields.studentId ? ticket.customFields.studentId : '_'}}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <div class="ticket-form-label">
              Tên học sinh
            </div>
          </v-col>
          <v-col cols="9">
            {{ticket.customFields && ticket.customFields.studentName ? ticket.customFields.studentName : '_'}}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <div class="ticket-form-label">
              Mã lớp
            </div>
          </v-col>
          <v-col cols="9">
            {{ticket.customFields && ticket.customFields.classCode ? ticket.customFields.classCode : '_'}}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <div class="ticket-form-label">
              Độ ưu tiên
            </div>
          </v-col>
          <v-col cols="9">
            <div v-if="ticket.priority" class="d-flex align-center">
              <div :style="`background: ${renderPriority(ticket.priority.id).color}`" class="priority-dot mr-2"></div>
              {{ renderPriority(ticket.priority.id).name}}
            </div>
            <div v-else class="d-flex">
              _
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <div class="ticket-form-label">
              Người xử lý
            </div>
          </v-col>
          <v-col cols="9">
            {{ticket.handler || '_'}}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <div class="ticket-form-label">
              Trạng thái xử lý
            </div>
          </v-col>
          <v-col cols="9">
            <div
              class="ticket-status-box"
              v-if="ticket.status"
              :style="`background: ${LIST_STATUS_SUPPORT.find((e) => e.name === ticket.status.name) ? LIST_STATUS_SUPPORT.find((e) => e.name === ticket.status.name).color : '#000000'}`"
              style="color: white">
              {{ ticket.status.name}}
            </div>
            <div v-else>
              _
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <div class="ticket-form-label">
              Mô tả
            </div>
          </v-col>
          <v-col cols="9">
            <v-textarea hide-details readonly outlined rows="2" v-model="ticket.customFields.description"></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <div class="ticket-form-label">
              File đính kèm
            </div>
          </v-col>
          <v-col cols="9">
            <img v-if="ticket.customFields && ticket.customFields.fileAttachment" style="cursor:pointer;" src="../assets/picture-preview.svg" alt="" @click="handleOpenPicture(ticket.customFields.fileAttachment)">
            <div v-else>--</div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <div class="ticket-form-label">
              Kết quả
            </div>
          </v-col>
          <v-col cols="9">
            {{ticket.result || '_'}}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <div class="ticket-form-label">
              Nội dung xử lý
            </div>
          </v-col>
          <v-col cols="9">
            <v-textarea hide-details readonly rows="2" outlined v-model="ticket.resultDetail">
            </v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <div class="ticket-form-label">
              Ngày tạo
            </div>
          </v-col>
          <v-col cols="9">
            {{formatDateCus(ticket.createdAt, 'DD/MM/YYYY HH:mm:ss') || '_'}}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <div class="ticket-form-label">
              Nhóm ticket
            </div>
          </v-col>
          <v-col cols="9">
            {{ticket.template && ticket.template.groupTicketName ? ticket.template.groupTicketName : '_'}}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <div class="ticket-form-label">
              Loại ticket
            </div>
          </v-col>
          <v-col cols="9">
            {{ticket.template && ticket.template.typeTicketName ? ticket.template.typeTicketName : '_'}}
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions >
        <v-btn color="#FA1E95" class="close-ticket-btn" @click="handleClose">
          Đóng
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import SupportRepository from '@/services/SupportRepository';
import { PRIORITY_SUPPORT, LIST_STATUS_SUPPORT } from '@/modules/ticket/const';

export default {
  name: 'TicketDetailPopup',
  props: {
    isShowTicketDetail: {
      type: Boolean,
      require: true,
    },
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      ticket: {
        customFields: {},
      },
      PRIORITY_SUPPORT,
      LIST_STATUS_SUPPORT,
    };
  },
  methods: {
    handleOpenPicture(url) {
      window.open(url, '_blank');
    },
    handleClose() {
      this.$emit('close');
    },
    renderPriority(value) {
      const priority = _.find(this.PRIORITY_SUPPORT, { value });
      return priority || '_';
    },
    async getTicketDetailDetail(id) {
      const loading = this.$loading.show();
      const response = await SupportRepository.getTicketDetail(id);
      if (response.message === 'Success') {
        this.ticket = response.data;
      }
      loading.hide();
    },
  },
  watch: {
    'item._id': function (val) {
      this.getTicketDetailDetail(val);
    },
  },
};
</script>

<style scoped>
.ticket-status-box {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 8px;
  border-radius: 5px;
  width: fit-content;
}
.ticket-card .v-card__title {
  background: #FA1E95;
  color: white;
  font-weight: bold;
  padding: 10px 24px;
}
.ticket-form-label {
  color: #646464;
}
.ticket-form-value {
  color: #272727;
}
.ticket-card .v-card__actions {
  display: flex;
  justify-content: center !important;
}
.close-ticket-btn {
  color: white;
  font-weight: bold;
}
.priority-dot {
  background: #000;
  border-radius: 50%;
  height: 10px;
  width: 10px;
}
</style>
